import {api} from './api';
import {AccessKeyRecord} from '../common/sharedView';

export type TimelineAccessKeyRecord = AccessKeyRecord & {
	timelineId: string;
};

export const timelineAccessKeysApi = api.injectEndpoints({
	endpoints: (builder) => ({
		timelineAccessKeysFind: builder.query<TimelineAccessKeyRecord[], {timelineId: string}>({
			query: (params) => ({
				url: 'timeline-access-keys/find',
				params,
			}),
			extraOptions: {maxRetries: 0},
		}),
		timelineAccessKeyGenerate: builder.mutation<TimelineAccessKeyRecord, {timelineId: string}>({
			query: (body) => ({
				url: 'timeline-access-keys/generate',
				method: 'POST',
				body,
			}),
			extraOptions: {maxRetries: 0},
		}),
		timelineAccessKeyDelete: builder.mutation<void, {shareLinkId: string}>({
			query: ({shareLinkId}) => ({
				url: `timeline-access-keys/${shareLinkId}`,
				method: 'DELETE',
			}),
			extraOptions: {maxRetries: 0},
		}),
	}),
});

export const {
	useTimelineAccessKeysFindQuery,
	useTimelineAccessKeyGenerateMutation,
	useTimelineAccessKeyDeleteMutation,
} = timelineAccessKeysApi;
